var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShowBubble)?_c('v-flex',{attrs:{"shrink":""}},[_c('app-notification-bubble',[_vm._v(_vm._s(_vm.badgeDisplayValue))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }